"use client";

import {
  toSnakeCase
} from "./chunk-ZNPQQ2WK.mjs";

// src/libraries/react/client/clientGenMethods.ts
async function attachMethod(params) {
  let { dialog, ...rest } = params;
  let snakeParams = toSnakeCase(rest);
  const res = await this.post("/api/autumn/attach", snakeParams);
  return res;
}
async function cancelMethod(params) {
  let snakeParams = toSnakeCase(params);
  const res = await this.post("/api/autumn/cancel", snakeParams);
  return res;
}
async function checkMethod(params) {
  let { dialog, ...rest } = params;
  let snakeParams = toSnakeCase(rest);
  const res = await this.post("/api/autumn/check", snakeParams);
  return res;
}
async function trackMethod(params) {
  let snakeParams = toSnakeCase(params);
  const res = await this.post("/api/autumn/track", snakeParams);
  return res;
}
async function openBillingPortalMethod(params) {
  let snakeParams = toSnakeCase(params || {});
  const res = await this.post("/api/autumn/billing_portal", snakeParams);
  return res;
}

export {
  attachMethod,
  cancelMethod,
  checkMethod,
  trackMethod,
  openBillingPortalMethod
};
